import {useState, useEffect} from 'react';
import NoAccountRedirectionPage from './NoAccountRedirectionPage';
import {MutualLoginRequest} from '../request/MutualLoginRequest'
import User from '../model/User'
import MutualLoginService from '../service/MutualLoginService'
import React from 'react';
import { Grid } from '@mui/material';
import { TailSpin } from  'react-loader-spinner'
 
type myState = {
	haveData: boolean;
	accountNotFound: boolean;
};

type props = {
    loginRequestProp : MutualLoginRequest
    width: number
    queryParamUrl : string | null
    setIsLogged: React.Dispatch<React.SetStateAction<boolean>>
    setMobileLogin :  React.Dispatch<React.SetStateAction<boolean>>
    handleAccountNotFound: (status : boolean) => void
}

const validQueryParams = ['/account', '/premium']


const Home: React.FC<props > = ({handleAccountNotFound, setMobileLogin, setIsLogged, queryParamUrl, loginRequestProp}) => {
    const [user, setUser] = useState<User>(new User('', '', '', '', false))
    const [state, setState] = useState<myState>({haveData: false, accountNotFound: false})
    const [loading, setLoading] = useState(true)

    let redirectUrl : string = '/account'

    if(queryParamUrl !== null && validQueryParams.includes(queryParamUrl)){
        redirectUrl = queryParamUrl
    }

    useEffect( () => {
        const fetchDataInHook = async () : Promise<void> => {
            const response = await MutualLoginService.getMutualLoginService(loginRequestProp);

            setUser(() => new User(
                    response.mutualID,
                    response.firstName,
                    response.lastName,
                    loginRequestProp.firebaseToken,
                    response.p_enabled
                ))

            // Did find a mutual account
            if (user.uuid !== '-1') {
                setState({ ...state, haveData: true });
                handleAccountNotFound(false)

            }
            // Did not find a mutual account
            if (!response.success) {
                setState({ ...state, accountNotFound: true });
                handleAccountNotFound(true)
                setMobileLogin(false)
                setIsLogged(false)
            }
            setLoading(false)
        };

        fetchDataInHook()
    }, [user.uuid, state, handleAccountNotFound, loginRequestProp, setIsLogged, setMobileLogin])

    if(loading){
        return (
            <Grid container flexDirection='column' justifyContent='center' alignItems='center' style={{height: '80vh'}}>
                <TailSpin
                    height="100"
                    width="100"
                    color='#FF3363'
                    ariaLabel='loading'
                />
            </Grid>
        )
    }
    else{
        if(state.accountNotFound){
            return (
                <NoAccountRedirectionPage setMobileLogin={ setMobileLogin} setIsLogged={ setIsLogged} />
            )
        }
        else{
            return (
                <span style={{display: 'none'}}>
                    {/* @ts-ignore */}
                    {window.location.replace(redirectUrl) }       
                </span>
            )
        }
    }
}

export default Home
  
